import React, { Component } from 'react';

export default class Sanitaer extends Component {
  
  componentDidMount() {
      try {
        window.adjustSubmenu();
      }
      catch(err) {
        console.log(err);
      }
  }
  
  render() {
    return (
      <div id="UeberUns">
        <div id="content" className="container" role="main">        
          <div id="Im Büro" className="block row section" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-1" description="HTML">
                <a name="im-buero"></a>
                <div id="leadteam">
                  <div>
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h2 className="section-heading">Im Büro</h2>
                        <h3 className="section-subheading text-muted">Ihre Ansprechpartner im Büro.</h3>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/julia_mall.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>Julia Mall</h4>
                          <p className="text-muted">Seit 2022 Geschäftsleitung.</p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/andre.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>André Michelberger</h4>
                          <p className="text-muted">Projektleiter Heizung und Planung Photovoltaikanlagen.</p>
                        </div>
                      </div>
                    </div>                      
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/morlock.JPG" className="img-responsive img-circle" alt="" />
                          <h4>Christina Digel-Morlock</h4>
                          <p className="text-muted">Seit April 2018 ist Frau Digel-Morlock bei uns im Team.</p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/xenia.JPG" className="img-responsive img-circle" alt="" />
                          <h4>Xenia Hoffmann</h4>
                          <p className="text-muted">Leitung Kundendienst.</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/franziska.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>Franziska Höckh</h4>
                          <p className="text-muted">Assistentin Projekte.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <a name="bei-ihnen-vor-ort"></a>
              </respond-html>
            </div>
          </div>
          <div id="Bei Ihnen vor Ort" className="block row section bg-light-gray" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-2" description="HTML">
                <div id="team">
                  <div>
                    <div className="row">
                      <div className="col-lg-12 text-center">
                        <h2 className="section-heading">Bei Ihnen vor Ort</h2>
                        <h3 className="section-subheading text-muted"></h3>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/ronny_junghanns.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>Ronny Junghanns</h4>
                          <p className="text-muted">Hat im September 2000 seine Ausbildung bei uns begonnen und ist
                              nach erfolgreichem Abschluss 2004 nun unser Fachmann rund um Sanitär- Heizungs- und
                                        Lüftungstechnik.</p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/peter.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>Peter Grabhorn</h4>
                          <p className="text-muted">Kundendiensttechniker</p>
                        </div>
                      </div>  
                    </div>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/dominik_ruf.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>Dominik Ruf</h4>
                          <p className="text-muted">Hat 2008 seine Ausbildung zum Anlagenmechaniker bei uns erfolgreich
                                        abgeschlossen. Seitdem unser Spezialist in Sachen Sanitär, Heizung, Klima.</p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/robin.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>Robin Siebler</h4>
                          <p className="text-muted">Ist unser Spezialist in Sachen Badrenovierung und Sanitärinstallation.</p>
                        </div>
                      </div>
                    </div>
                    <div className="row">                    
                    <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/kevin_anton.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>Kevin Anton</h4>
                          <p className="text-muted">Techniker für Heizungssanierung.</p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/Marius.jpeg" className="img-responsive img-circle" alt="" />
                          <h4>Marius Rummler</h4>
                          <p className="text-muted">Auszubildender</p>
                        </div>
                      </div>                
                    </div>
                    <div className="row">                    
                    <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/pailer_car.JPG" className="img-responsive img-circle" alt="" />
                          <h4>Luke Wolff</h4>
                          <p className="text-muted">Auszubildender</p>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="team-member">
                          <img src="files/about/pailer_car.JPG" className="img-responsive img-circle" alt="" />
                          <h4>Jeremy Leber</h4>
                          <p className="text-muted">Auszubildender</p>
                        </div>
                      </div>                
                    </div>                   
                  </div>
                </div>
                <a name="unsere-firmenhistorie"></a>
              </respond-html>
            </div>
          </div>
          <div className="section">
            <div id="team">
              <img src="files/about/team.jpeg" class="img-fluid img-responsive center-block" alt="Team Pailer"></img>
            </div>
          </div>
          <div id="Unsere Firmenhistorie" className="block row section" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-3" description="HTML">
                <div id="about">
                  <div className="row">
                    <div className="col-lg-12 text-center">
                      <h2 className="section-heading">Unsere Firmenhistorie</h2>
                      <h3 className="section-subheading text-muted">1887 bis heute</h3>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <ul className="timeline">
                        <li>
                          <div className="timeline-image">
                            <img className="img-circle img-responsive" src="files/about/ludwig-pailer.png" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>1887</h4>
                              <h4>Ludwig Pailer</h4>
                              <h4 className="subheading">Gründung des Betriebs</h4>
                            </div>
                            <div className="timeline-body">
                              <p className="text-muted">Im Jahre 1887 gründete Ludwig Pailer im Alter von 16 Jahren
                                  die Firma. Er arbeitete zunächst nur im Bereich Blechnerei. Mit nur einem
                                  Leiterwagen mit langer Deixel erledigte er Arbeiten wie die Installation
                                  von Dachrinnen Regenabläufen und Blechdächer. Nebenbei bewirtschaftete er
                                  auch noch eine kleine Landwirtschaft mit Kühen und Ziegen. Zeitungsberichten
                                  von 1855 ist zu entnehmen, dass man ihn neben seiner beruflichen Tätigkeit
                                  auch täglich auf seinen Feldern arbeiten sah. Von 1892 an, begann er sein
                                  eigenes Haus zu bauen und nach ca. zwei Jahren Bauzeit zog er 1894 in das
                                                Anwesen in der Kronenstraße ein.</p>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-image">
                            <img className="img-circle img-responsive" src="files/about/emil-pailer.png" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>1933</h4>
                              <h4>Emil Pailer</h4>
                              <h4 className="subheading">Erwarb das erste motorisierte Firmenfahrzeug</h4>
                            </div>
                            <div className="timeline-body">
                              <p className="text-muted">1933 übergab Ludwig Pailer dann die Firma an seinen Sohn
                                  Emil Pailer. Dieser führte mit 37 Jahren den Betrieb weiter und baute die
                                  Firma weiter aus, die ersten Wasserleitungen wurden in den Gebäuden verlegt
                                  somit kam der Bereich Sanitärinstallation hinzu. Emil Pailer erwarb das erste
                                  Firmenfahrzeug, ein Dreirad mit Britsche. So war man mobiler und konnte die
                                  Kunden um einiges leichter erreichen. Die Firma Pailer, nunmehr in der 2.
                                  Generation überstand unter der Leitung von Emil Pailer den zweiten Weltkrieg
                                                und bewältigte einige wirtschaftliche Schwierigkeiten.</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="timeline-logo">
                            <img className="img-responsive" src="files/about/logo-1.png" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>1933</h4>
                              <h4>Erstes Firmenlogo</h4>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-image">
                            <img className="img-circle img-responsive" src="files/about/willi-pailer.png" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>1962</h4>
                              <h4>Willi Pailer</h4>
                              <h4 className="subheading">Erste Mitarbeiter wurden eingestellt</h4>
                            </div>
                            <div className="timeline-body">
                              <p className="text-muted">Eigentlich sollte der ältere Sohn Kurt Pailer den Betrieb
                                  übernehmen, was die Wirrungen des Krieges leider nicht zuließen und so übernahm
                                  der jüngere Bruder Willi Pailer im Alter von 40 Jahren den Familienbetrieb.
                                  Nachdem es nach dem zweiten Weltkrieg wieder langsam aufwärts ging mit der
                                  Wirtschaft, stellte Willi Pailer die ersten Mitarbeiter ein: Werner Leber
                                  und Karlheinz Rentschler. Die Buchhaltung wurde von dessen Ehefrau Erna Pailer
                                                bestelllt.</p>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-logo">
                            <img className="img-responsive" src="files/about/logo-2.png" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>1971</h4>
                              <h4>Neues Firmenlogo</h4>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-image">
                            <img className="img-circle img-responsive" src="files/about/kurt_pailer.JPG" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>1979 </h4>
                              <h4>Kurt Pailer</h4>
                              <h4 className="subheading">Seit 1979 leitet nun Kurt Pailer in der 4. Generation</h4>
                            </div>
                            <div className="timeline-body">
                              <p className="text-muted">Willi Pailer konnte krankheitsbedingt den Betrieb nur 17
                                  Jahre lang leiten. Als er im Jahr 1979 im Alter von 57 Jahren verstarb, übernahm
                                  sein jüngster Sohn Kurt Pailer den Betrieb. Kurt Pailer kannte den Betrieb
                                  von der Pike auf. Er lernte bei Firma Jakob Engel in Pforzheim und arbeitete
                                  ab 1977 im väterlichen Betrieb mit. Kurt Pailer leitet den Betrieb nunmehr
                                                schon 28 Jahre. Zwischenzeitlich hatte der Betrieb 12 Mitarbeiter.</p>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-logo">
                            <img className="img-responsive" src="files/about/logo-3.png" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>2001</h4>
                              <h4>Heutiges Firmenlogo</h4>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-logo">
                            <img className="img-responsive" src="files/about/125-jahre.png" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>2007</h4>
                              <h4>120 Jahre Firma Pailer</h4>
                              <p className="text-muted">Unser 120 jähriges Firmenjubiläum feiern wir mit einer
                                                großen Hausmesse in der Kulturhalle in Remchingen-Wilferdingen</p>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-image">
                            <img className="img-circle img-responsive" src="files/about/julia_mall.jpeg" alt="" />
                          </div>
                          <div className="timeline-panel">
                            <div className="timeline-heading">
                              <h4>2022 </h4>
                              <h4>Julia Mall</h4>
                              <h4 className="subheading">Seit 2022 leitet Julia Mall in der 5. Generation</h4>
                            </div>
                            <div className="timeline-body">
                              <p className="text-muted"></p>
                            </div>
                          </div>
                        </li>
                        <li className="timeline-inverted">
                          <div className="timeline-image">
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <a name="wir-bilden-aus"></a>
              </respond-html>
            </div>
          </div>
          <div id="Wir bilden aus" className="block row" data-nested="not-nested" data-containerid="" data-containercssclass="">
            <div className="col col-md-12">
              <respond-html id="html-4" description="HTML">
                <div className="section bg-light-gray">
                  <div className="row p-b">
                    <div className="col col-md-12">
                      <h2 className="text-center">Wir bilden aus!</h2>
                      <h3 className="text-center section-subheading text-muted">Die Ausbildung junger Leute zu qualifiziertem
                          Fachpersonal liegt uns seit Jahren am Herzen. So bilden wir seit nahezu 120 Jahren jedes
                                Jahr aus ...</h3>
                      <h3 className="text-center">Anlagenmechaniker/- in für Sanitär-, Heizungs- und Klimatechnik
                            </h3>
                      <p className="text-center">Der Anlagenmechaniker/- in für Sanitär-, Heizungs- und Klimatechnik ist
                          zuständig für die Montage von Rohrleitungen für technische Anlagen der Ver- und Entsorgung,
                          das Installieren von Gasversorgungsanlagen und sanitären Einrichtungen oder Wasser- und Abwasseranlagen.
                          Das Aufstellen und Montieren von heizungs- und raumlufttechnischen Anlagen sowie Brennstoff-
                          und Feuerungsanlagen gehören ebenfalls zu diesem Berufsbild.
                            </p>
                    </div>
                  </div>
                  <div className="row same-height-box">
                    <div className="col-sm-6 col-md-4">
                      <div className="same-height shadowbox-white shadow-border-top">
                        <div className="panel-heading">
                          <h3>Ausbildungsinhalte</h3>
                        </div>
                        <div className="panel-body">
                          <ul>
                            <li>Rohrleitungen, Kanäle und Ver- bzw. Entsorgungskomponenten montieren und demontieren</li>
                            <li>Regel, Steuer- und Sicherheitseinrichtungen kontrollieren, überprüfen und einstellen</li>
                            <li>Elektrische Bauteile installieren und prüfen</li>
                            <li>Versorgungstechnik installieren, prüfen, einstellen, optimieren, warten</li>
                            <li>Versorgungstechnik dem Kunden übergeben und in die Bedienung einweisen</li>
                            <li>Inspektion, Wartung und Instandsetzungen durchführen</li>
                            <li>Kundenberatung zu Produkten, Dienstleistungen, Umweltschutz und Energieeinsparungen</li>
                            <p></p>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4">
                      <div className="same-height shadowbox-white shadow-border-top">
                        <div className="panel-heading">
                          <h3>Das bringen Sie mit</h3>
                        </div>
                        <div className="panel-body">
                          <ul>
                            <li>guter Hauptschulabschluss</li>
                            <li>mathematisches Verständnis</li>
                            <li>Talent für präzises Arbeiten mit moderner Technik</li>
                            <li>Handwerkliches Geschick</li>
                            <li>Freude im Team zu arbeiten</li>
                            <li>Freude am Umgang mit Menschen</li>
                            <li>Power, um auch kräftig anzupacken</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 col-md-4">
                      <div className="same-height shadowbox-white shadow-border-top">
                        <div className="panel-heading">
                          <h3>Ausbildungsdauer</h3>
                        </div>
                        <div className="panel-body">
                          <p>3-4 Jahre </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="shadowbox-white shadow-border-top">
                    <div className="panel-heading">
                      <h3>Bitte richten Sie Ihre Bewerbung</h3>mit Lebenslauf und Zeugnissen an:
                        </div>
                    <div className="panel-body">
                      <div className="row">
                        <div className="col col-md-9">
                          <div className="row">
                            <div className="col col-md-3">
                              <div className="contact">
                                <img src="files/about/julia_mall.jpeg" className="img-responsive img-circle" alt="" />
                              </div>
                            </div>
                            <div className="col col-md-9">
                              <p>
                                <br></br>
                                <b>Julia Mall</b>
                                <br></br>
                                <b>Kinzigstr. 4</b>
                                <br></br>
                                <b>75196 Remchingen Wilferdingen</b>
                                <br></br>
                                <br></br> Für Rückfragen rufen Sie uns gerne an (07232 / 37 25 06).
                                            </p>
                            </div>
                          </div>
                        </div>
                        <div className="col col-md-3">
                          <p>
                            <b>Weiterführende Links:</b>
                          </p>
                          <p>
                            <a href="http://www.kh-pforzheim.de" target="blank">http://www.kh-pforzheim.de</a>
                          </p>
                          <p>
                            <a href="http://www.shkinnung-pforzheim.de" target="blank">http://www.shkinnung-pforzheim.de</a>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </respond-html>
            </div>
            <div className="col col-md-12"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-12"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-12"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-12"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-12"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-12"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-12"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
            <div className="col col-md-9"></div>
            <div className="col col-md-3"></div>
          </div>
        </div>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/ueber-uns/UeberUns.js